// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2SJJE","bigColWidth":"Table_bigColWidth__19QYx","biggerColWidth":"Table_biggerColWidth__n-Kvn","row":"Table_row__nCe8S","col":"Table_col__1BFLg"};